import React, { useState, useCallback } from 'react'
import MyPlannerHeading from './MyPlannerHeading'
import MyPlannerList from './List/MyPlannerList'

function MyPlannerTasks({filter, setFilter, filteredTasks}) {
     
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [inputValue, setInputValue] = useState("");

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleOpen = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const memoizedSetSearchText = useCallback((value) => {
        setSearchText(value);
    }, []);

  return (
    <div>
        <MyPlannerHeading 
            filter={filter} 
            filteredTasks={filteredTasks} 
            anchorEl={anchorEl} 
            setFilter={setFilter} 
            handleOpen={handleOpen} 
            handleClose={handleClose}
            inputValue={inputValue}
            setInputValue={setInputValue}
            // searchText={searchText}
            // setSearchText={memoizedSetSearchText}
        />
        <MyPlannerList 
            filter={filter} 
            filteredTasks={filteredTasks.filter((task) => task?.title?.toLowerCase().includes(inputValue.toLowerCase()))} 
            anchorEl={anchorEl} 
            setFilter={setFilter} 
            handleOpen={handleOpen} 
            handleClose={handleClose}
            searchText={searchText}
            inputValue={inputValue}
        />
    </div>
  )
}

export default MyPlannerTasks